import {parsePhoneNumber,getCountryCallingCode} from 'libphonenumber-js';
import {findFlagUrlByIso2Code} from "country-flags-svg"

const DEMO_MSISDNS = ['00000000000'];
const isDemoMsisdn = (number) => DEMO_MSISDNS.includes(number);

// The portal uses "uk", but the ISO 3166-1 code libphonenumber-js and country-flags-svg expect is "GB".
const ISO_COUNTRY_OVERRIDES = { UK: 'GB' };
const toIsoCountry = (country) => {
    const code = country.toUpperCase();
    return ISO_COUNTRY_OVERRIDES[code] || code;
}

const parse=(number,country)=>{
    if(country === "xx" || isDemoMsisdn(number)) return number;
    try{
        const parsed=parsePhoneNumber(number,toIsoCountry(country));
        return parsed.number.replace("+","");
    }
    catch(e){
        return number;
    }
}

const isValid=(number,country)=>{
    if(country === "xx" || isDemoMsisdn(number)) return true;
    try{
        const parsed=parsePhoneNumber(number,toIsoCountry(country));
        return parsed.isPossible();
    }
    catch(e){
        return false;
    }
}

const getPlaceHolder=(country)=>{
    if(country === 'xx') return "Your Number";
    try{
        return getCountryCallingCode(toIsoCountry(country)) + "xxxxxxxx";
    }
    catch(e){
        return "Your Number";
    }
}

const getFlag = (country) => {
    if(country === "xx") return null;
    else return findFlagUrlByIso2Code(toIsoCountry(country));
}


export {parse,isValid,getPlaceHolder, getFlag}